import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthService {
  constructor(private cookieService: CookieService) {}
  getAuthToken(): string {
    return JSON.parse(sessionStorage.getItem('accessToken') || '{}');
    // return JSON.parse(this.cookieService.get('accessToken') || '{}');
  }
  userLogout() {
    // return sessionStorage.removeItem('accessToken,isUserLogged');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('isUserLogged');
    return this.cookieService.deleteAll();
  }
  get isLoggedIn(): boolean {
    const user = JSON.parse(sessionStorage.getItem('isUserLogged') as string);
    return user !== null ? true : false;
  }
  isExpiryToken() {
    const Expiry = JSON.parse(sessionStorage.getItem('ExpiryTime') as string);
    let DateNow = new Date();
    let currentDate = DateNow.setDate(DateNow.getDate());
    if (Expiry < currentDate) {
      console.log('check');
    }
    // return JSON.parse(sessionStorage.getItem('ExpiryTime') as string);
  }
}
